import { render, staticRenderFns } from "./ClientContactHistoryContainer.vue?vue&type=template&id=781e58d2&scoped=true&"
import script from "./ClientContactHistoryContainer.vue?vue&type=script&lang=js&"
export * from "./ClientContactHistoryContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781e58d2",
  null
  
)

export default component.exports